<template>
  <div class="add-song">
     <button v-if="!toggleAdd" @click.prevent="toggleAdd = !toggleAdd">Add Songs</button>
     <form v-if="toggleAdd">
       <h4>Add a New Song</h4>
       <input type="text" placeholder="Song title" v-model="title" required>
       <input type="text" placeholder="Artist" v-model="artist" required>
       <button @click.prevent="handleSubmit">Add</button>
       <button @click.prevent="toggleAdd = !toggleAdd" class="cancel-btn">Cancel</button>
     </form>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import getUser from '../composables/getUser'
import useDocument from '../composables/useDocument'
export default {
    props: ['playlist'],
    setup(props) {
      const title = ref('');
      const artist = ref('');
      const { user } = getUser();
      const toggleAdd = ref(false);
      const { updateDoc } = useDocument('playlists', props.playlist.id)
      const handleSubmit = async () => {
        const newSong = {
          title: title.value,
          artist: artist.value,
          id: Math.floor(Math.random()*100000),
        };
        // 展開舊歌加上新歌，傳入更新
        const res = await updateDoc({songs:[...props.playlist.songs, newSong]});
        title.value = '';
        artist.value = '';
      }
      const ownerShip = computed(() => {
        return props.playlist.value && user.value && props.playlist.value.userId === user.value.uid;
      })
      return { title, artist, toggleAdd, handleSubmit, ownerShip }
    }
}
</script>

<style scoped>
  .add-song {
    text-align: center;
    margin-top: 40px;
  }
  form {
    max-width: 100%;
    text-align: left;
  }
  button.cancel-btn {
    margin-left: 16px;
  }
  
</style>